import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import DailyClosingComponent from './daily-closing.component';

let DailyClosingModule = angular
  .module('DailyClosing', [
    uiRouter
  ])
  .component('dailyclosing', DailyClosingComponent)
  .config(($stateProvider)=> {
    "ngInject";
    $stateProvider.state('dailyClosing', {
      url: '/daily-closing',
      data: {
        authRequired: true,
        permsRequired: ['daily-closing']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'dailyclosing'
        }
      }
    })
  })
  .name;

export default DailyClosingModule;



// WEBPACK FOOTER //
// ./src/app/pages/daily-closing/daily-closing.module.js